import type { ReactNode } from 'react';

/**
 * Placeholder provider — the current `<Tooltip>` is fully self-contained so no
 * shared state is needed yet. The provider exists so we can swap in a managed
 * positioning engine (Floating UI, Radix-style) without touching call sites.
 */
export function TooltipProvider({ children }: { children: ReactNode }) {
  return <>{children}</>;
}
